import {Component, OnInit} from '@angular/core';
import {DomainNameParserService} from 'src/main/resources/static/angular2/app/shared/services/domain-name-parser.service';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css']
})
export class LoginPageComponent implements OnInit {

  stylingScheme: string;
  favIcon: HTMLLinkElement = document.querySelector('#appIcon');

  constructor(private domainNameParserService: DomainNameParserService) {
    this.stylingScheme = this.domainNameParserService.getState()
    this.favIcon.href = this.favIcon.baseURI + "favicon" + this.stylingScheme + ".ico";
  }

  ngOnInit(): void {
  }

}
